const BasicLayout = ({ children }) => {
  return children;
};

export default BasicLayout;
